export default {"src":"/_next/static/media/generic-thumbnail-mp3.1c968f26.svg","height":92,"width":66,"blurWidth":0,"blurHeight":0};